import { DefaultTheme } from 'styled-components';

import sizes from './sizes';
import device from './device';
import general from './general';
import zIndices from './zindices';
import typography from './typography';
import transitions from './transitions';
import colorDefinitions from './colors';
import breakpoints from './breakpoints';

import dark from './variant/dark';
import light from './variant/light';

const commonThemeProps: DefaultTheme = {
  variants: {
    light,
    dark,
  },
  colors: light,
  colorDefinitions,
  transitions,
  sizes,
  typography,
  zIndices,
  general,
  device,
  breakpoints,
};

const theme: DefaultTheme = {
  ...commonThemeProps,
};

export default theme;
